import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import AuthModal from "./components/AuthModal";
import SearchModal from "./components/SearchModal";
import AuthCallback from "./components/AuthCallback";
import ArchivePage from "./pages/ArchivePage";
import DirectoryPage from "./pages/DirectoryPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import DealsPage from "./pages/DealsPage";
import LoungePage from "./pages/LoungePage";
import Home from "./pages/Home";
import ArticlePage from "./pages/ArticlePage";
import CategoryPage from "./pages/CategoryPage";
import VoicesPage from "./pages/VoicesPage";
import AdminPage from "./pages/AdminPage";
import ProfilePage from "./pages/ProfilePage";
import ReadingListPage from "./pages/ReadingListPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen bg-obsidian text-porcelain font-sans grain">
      <ScrollToTop />
      <Nav onSearch={() => setSearchOpen(true)} />
      <main className="pt-[136px]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/article/:slug" element={<ArticlePage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/voices" element={<VoicesPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/member/:id" element={<ProfilePage />} />
          <Route path="/reading-list" element={<ReadingListPage />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentSuccessPage cancelled />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/lounge" element={<LoungePage />} />
        </Routes>
      </main>
      <Footer />
      <AuthModal />
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
